import React from "react";
import { useLocation } from "react-router-dom";
import { useSwitch } from "../../context/SwitchContext";
import EN from "../../locales/en";
import WhiteErrorIcon from "../icons/WhiteErrorIcon";

const SwitchingFormErrorsAlertBar = () => {
  const { showSwitchingFormErrorsAlert } = useSwitch();
  const location = useLocation();
  const isSwitchPage = location.pathname.startsWith("/switch/");

  return (
    showSwitchingFormErrorsAlert &&
    isSwitchPage && (
      <div className="flex items-center justify-center p-0 text-center text-white m-0 sticky top-0 z-50 bg-error-gradient">
        <div className="flex items-center justify-center py-7 px-3 font-semibold">
          <WhiteErrorIcon className="w-6 h-6 mr-2" />
          {EN.switch.error_banner}
        </div>
      </div>
    )
  );
};

export default SwitchingFormErrorsAlertBar;
